import './UploadComp.scss';
import {useRef} from "react";
import {useIntl} from "react-intl";

export default function UploadPdfFile(
    {
        file,
        setFile,
        fileUrl,
        className = ""
    }
) {

    const intl = useIntl()
    const inputRef = useRef()

    return (<div className={className}>
            <input type={"file"}
                   ref={inputRef}
                   accept=".pdf"
                   style={{display: "none"}}
                   multiple={false}
                   onChange={(e) => {
                       setFile(e.target.files[0])
                   }}
            />
            <div className={"upload-image-comp"} onClick={() => inputRef.current.click()}>
                {
                    file !== null || fileUrl ?
                        <div className={"preview"}>
                            <div>
                                <i style={{fontSize: '2rem'}} className="fa-regular fa-file-pdf"></i>
                                <div className={"title"}>{file ? file.name : ''}</div>
                            </div>
                        </div>
                        :

                        <>
                            <i className="fa-regular fa-images icon"></i>
                            <div className={"title"}>{intl.formatMessage({id: "general.upload.pdf.title"})}</div>
                            <div className={"info"}>{intl.formatMessage({id: "general.upload.pdf.info"})}</div>
                        </>

                }
            </div>
        </div>
    );
}

